import React from 'react';

import {
  List,
} from '@mui/material';

import type { AttendContactLeaveEarlyJson } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import CustomListItem from '@/components/CustomListItem';
import { ChildId } from '@/domain/attendContact/service/entity/valueObjects/childId';
import { LeaveEarlyDateTime } from '@/domain/attendContact/service/entity/valueObjects/leaveEarlyDateTime';
import { Memo } from '@/domain/attendContact/service/entity/valueObjects/memo';
import { toStringDateDisplay, toStringTimeDisplay } from '@/utils/date';

/** プロパティ */
export type Props = {
  /** データ */
  data: AttendContactLeaveEarlyJson,
}

const LeaveEarlyInfo: React.FC<Props> = ({ data }) => {
  const {
    childId,
    leaveEarlyDateTime,
    memo,
  } = data.data;
  return (
    <>
      <List>
        <CustomListItem
          name={ChildId.label}
          content={childId}
        />
        <CustomListItem
          name={LeaveEarlyDateTime.labelDate}
          content={toStringDateDisplay(new Date(leaveEarlyDateTime))}
        />
        <CustomListItem
          name={LeaveEarlyDateTime.labelTime}
          content={toStringTimeDisplay(new Date(leaveEarlyDateTime))}
        />
      </List>
      <p style={{ marginLeft: '12px', color: '#666' }}>{Memo.label}</p>
      <p style={{ marginLeft: '24px' }}>{memo}</p>
    </>
  );
};

export default LeaveEarlyInfo;
